<template>
  <div class="fee-table">
    <div class="single-transaction">Single Transaction Amount</div>
    <div v-for="channel in feeData" :key="channel.channel_name" class="channel">
      <div class="first-col">
        <div class="channel-name">{{ channel.channel_name }}</div>
      </div>
      <div class="other-col" :class="{'other-col-border':compChannelFee(channel.channel_sub_templates).length>2}">
        <div v-for="feeItem in compChannelFee(channel.channel_sub_templates)" :key="feeItem.id" class="fee-col">
          <div class="row-1">{{ compScope(feeItem) }}</div>
          <div class="row-2">{{ compNumber(feeItem) }} </div>
        </div>
      </div>

    </div>
    <div class="fee-tip">
      The fees are determined by the transaction amount
    </div>

  </div>

</template>
<script>

export default {
  name: 'ChannelFee',
  props: ['feeData'],
  data() {
    this.billingTypeObj = {
      'fixed_amount': 1,
      'fixed_percentage': 2,
      'fixed_amount_ladder': 3,
      'fixed_percentage_ladder': 4,
      'fixed_amount_and_fixed_percentage_smaller': 5,
      'fixed_amount_and_fixed_percentage_bigger': 6,
      'fixed_amount_or_percentage_ladder': 7
    }
    this.singleType = {
      'amount': 2,
      'percentage': 1
    }
    return {
      channelNameList: []
    }
  },
  computed: {
    compScope() {
      return function(feeItem) {
      // fee_amount '计费-金额/万分比',
      // fee_structure '计费模式 0 默认 1 统一计费 2 单比阶梯计费',
        const toDivide100 = this.$options.filters['toDivide100']
        // 统一计费
        if (feeItem.fee_structure === 1) {
          return 'All Transactions'
        }
        // 单比阶梯计费
        if (feeItem.fee_structure === 2) {
          return `${toDivide100(feeItem.fee_scale_begin)} - ${toDivide100(feeItem.fee_scale_end)}`
        }
      }
    },
    compNumber() {
      return function(feeItem) {
        // single_type  '收费类型 0 默认 1 比例计费 2 固定计费'
        const toDivide100 = this.$options.filters['toDivide100']
        // 比例计费
        if (feeItem.single_type === this.singleType['percentage']) {
          if (feeItem.minAmount) {
            return `${toDivide100(feeItem.fee_amount)} % with minimum of PHP ${feeItem.minAmount}`
          }
          if (feeItem.maxAmount) {
            return `${toDivide100(feeItem.fee_amount)} % with maximum of PHP ${feeItem.maxAmount}`
          }
          return `${toDivide100(feeItem.fee_amount)} %`
        }
        // 固定计费
        if (feeItem.single_type === this.singleType['amount']) {
          return `₱ ${toDivide100(feeItem.fee_amount)}`
        }
      }
    },
    compChannelFee() {
      return function(feeChannel) {
        const toDivide100 = this.$options.filters['toDivide100']
        // 取小 封顶
        if (feeChannel[0].fee_type === this.billingTypeObj['fixed_amount_and_fixed_percentage_smaller']) {
          const amountList = feeChannel.filter(item => item.single_type === this.singleType['amount'])
          const percentagetList = feeChannel.filter(item => item.single_type === this.singleType['percentage'])
          percentagetList[0].maxAmount = toDivide100(amountList[0]['fee_amount'])
          return percentagetList
        }
        // 取大 保底
        if (feeChannel[0].fee_type === this.billingTypeObj['fixed_amount_and_fixed_percentage_bigger']) {
          const amountList = feeChannel.filter(item => item.single_type === this.singleType['amount'])
          const percentagetList = feeChannel.filter(item => item.single_type === this.singleType['percentage'])
          percentagetList[0].minAmount = toDivide100(amountList[0]['fee_amount'])
          return percentagetList
        }

        return feeChannel
      }
    }

  }
  // watch: {
  //   feeData: {
  //     handler: function() {
  //       if (Object.prototype.toString.call(this.feeData) === '[object Object]') {
  //         this.channelNameList = Object.keys(this.feeData)
  //       }
  //     },
  //     immediate: true
  //   }
  // }
}
</script>
<style scoped lang="scss">
.fee-table{
    margin-top: 32px;
max-height: 600px;
    overflow: auto;
    &::-webkit-scrollbar-track-piece {
      background: #d3dce6;
    }

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: #99a9bf;
      border-radius: 20px;
    }
}
.single-transaction{
  margin-left: 111px;
  margin-bottom: 24px;
  color: #000;
  font-size: 12px;
  font-weight: 600;
}
.fee-tip{
  margin-left: 111px;
  margin-bottom: 16px;
  color: #3855F1;
  font-size: 12px;
  font-weight: 500;
}

 .channel{
    display: flex;
    width: 100%;
    overflow: hidden;
    margin-bottom: 30px;
    .channel-name{
        font-size: 12px;
        color: #1D3A71;
        font-weight: bold;
        word-break: keep-all;
    }

    .first-col{
        flex-shrink: 0;
        width: 95px;
        margin-right: 16px;
    }
    .other-col{
      white-space: nowrap;
      overflow-x: auto;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;
    }
    .fee-col{
        display: inline-block;
        min-width: 100px;
        margin-right: 16px;
    }
    .row-1{
        color: #000;
        font-weight: bold;
    }
    .other-col-border{
      // position: relative;
       border-bottom: 2px solid #aaa;
    }

    .row-1,.row-2{
        // border: 1px solid #D6D6D6;
        white-space: pre-wrap;
        padding-bottom: 10px;
        font-size: 12px;
    }
}
</style>
